import React from 'react';
import {versionSort} from '../common/arraySort';
import FilterTable from './filterTable';
import {ProductReleaseTableColumnCaptions} from './tableColumnCaptions';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';

const ProductReleaseTable = props => {
  let productNameFilterValues = { 'all': '' };
  props.products.forEach(product => productNameFilterValues[product.name] = product.name);
  const columns = [{
    dataField: 'productName',
    text: ProductReleaseTableColumnCaptions['productName'],
    sort: true,
    filter_: {
      type: 'select',
      values: productNameFilterValues
    }
  }, {
    dataField: 'productVersion',
    text: ProductReleaseTableColumnCaptions['productVersion'],
    sort: true,
    filter_: { type: 'text' },
    sortFunc: (a, b, order) => versionSort(3, a, b, order)
  }, {
    dataField: 'releaseDate',
    text: ProductReleaseTableColumnCaptions['releaseDate'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'isFavorite',
    text: ProductReleaseTableColumnCaptions['isFavorite'],
    sort: false,
    align: 'center',
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'favorite': 'true',
      },
    },
    headerStyle: () => ({width: '35px'}),
    formatter: (cell, row) => <FavoriteItemColumnFormatter
      cell={cell} row={row}
      actions={props.actions}/>,
  }];

  const defaultSorted = [{
    dataField: 'releaseDate',
    order: 'asc'
  }];

  return (
    <FilterTable
      {...props}
      objectName={'productReleases'}
      data={props.productReleases}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no product releases"
    />
  );
};

export default ProductReleaseTable;



// WEBPACK FOOTER //
// ./src/components/productReleaseTable.js